module.exports = __webpack_public_path__ + "images/124_160.jpg";